import * as React from "react";
import { Box, Typography, Button } from "@mui/material";
import { MainInput, sec_button } from "./Styles";
import { clampFaultyQuantity, okQuantityFromReceive } from "./inboundFaultySplit";

/**
 * Compact receive split: Received + Faulty side by side, quiet destination readout.
 */
export default function InboundFaultySplitFields({
  quantityReceived,
  faultyQuantity = 0,
  onQuantityChange,
  onFaultyChange,
  quantityLabel = "Received",
  faultyLabel = "Faulty",
  quantityDisabled = false,
  quantityMin = 0,
  quantityMax,
  quantityHelperText,
  showQuickActions = false,
  dense = false,
}) {
  const received = Math.max(0, parseInt(quantityReceived, 10) || 0);
  const faultyQty = clampFaultyQuantity(received, faultyQuantity);
  const okQty = okQuantityFromReceive(received, faultyQuantity);

  const summary =
    received <= 0
      ? "Enter received quantity"
      : faultyQty === 0
        ? `${okQty} to Available`
        : faultyQty === received
          ? `${faultyQty} to Returns`
          : `${okQty} Available · ${faultyQty} Returns`;

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: dense ? 1 : 1.5,
        }}
      >
        <MainInput
          value={received}
          label={quantityLabel}
          onChange={({ target }) => onQuantityChange?.(parseInt(target.value, 10) || 0)}
          type="number"
          disabled={quantityDisabled}
          fullWidth
          size={dense ? "small" : "medium"}
          inputProps={{
            min: quantityMin,
            ...(quantityMax != null ? { max: quantityMax } : {}),
          }}
        />
        <MainInput
          value={faultyQty}
          label={faultyLabel}
          onChange={({ target }) => onFaultyChange?.(parseInt(target.value, 10) || 0)}
          type="number"
          disabled={quantityDisabled || received <= 0}
          fullWidth
          size={dense ? "small" : "medium"}
          inputProps={{
            min: 0,
            max: received,
          }}
        />
      </Box>
      <Typography
        variant="caption"
        color={quantityHelperText ? "warning.main" : "text.secondary"}
        sx={{ display: "block", mt: 0.75, lineHeight: 1.35 }}
      >
        {quantityHelperText ? `${quantityHelperText} · ${summary}` : summary}
      </Typography>
      {showQuickActions && received > 0 && (
        <Box sx={{ display: "flex", gap: 0.5, mt: 0.5 }}>
          <Button
            size="small"
            onClick={() => onFaultyChange?.(0)}
            disabled={faultyQty === 0}
            sx={{ ...sec_button, py: 0, px: 1, minWidth: 0, fontSize: 12 }}
          >
            All OK
          </Button>
          <Button
            size="small"
            onClick={() => onFaultyChange?.(received)}
            disabled={faultyQty === received}
            sx={{ ...sec_button, py: 0, px: 1, minWidth: 0, fontSize: 12 }}
          >
            All Faulty
          </Button>
        </Box>
      )}
    </Box>
  );
}
